module.exports = __webpack_public_path__ + "img/201.5a8b04d0.png";